import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import EmployeeList from './EmployeeList';
import EmployeeDetail from './EmployeeDetail';
import { getCurrentUserEmployee } from '../services/apiService';
import { Employee } from '../types';

const Home: React.FC = () => {
  const { user } = useAuth();
  const [currentUserEmployee, setCurrentUserEmployee] = useState<Employee | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchCurrentUserEmployee = async () => {
      if (!user || user.isAdmin) {
        setLoading(false);
        return;
      }

      try {
        // Fetch the current user's employee record directly
        const userEmployee = await getCurrentUserEmployee();
        setCurrentUserEmployee(userEmployee);
      } catch (error) {
        console.error('Error fetching current user employee:', error);
        setCurrentUserEmployee(null);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentUserEmployee();
  }, [user]);

  if (loading) {
    return <div className="loading">Lädt...</div>;
  }

  // Admin users see the employee list
  if (user?.isAdmin) {
    return <EmployeeList />;
  }

  // Non-admin users see their own detail page
  // We render EmployeeDetail directly without changing the URL
  if (currentUserEmployee) {
    return <EmployeeDetail employeeName={currentUserEmployee.name} />;
  }

  // Fallback if no employee record found
  return (
    <div className="error">
      Kein Mitarbeiterdatensatz für den aktuellen Benutzer gefunden.
    </div>
  );
};

export default Home;
